"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderListOfImageCards = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("./index"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderListOfImageCards = archive => {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "con-archive-list"
  }, archive.images.map(image => {
    return /*#__PURE__*/_react.default.createElement(_index.default, {
      imageId: image.id,
      key: image.id,
      imageUrl: archive.imagesDirectory + '/thumbnails/' + image.imageName
    });
  }));
};
exports.renderListOfImageCards = renderListOfImageCards;